import {
  Box,
  Button,
  Input,
  Field,
  Flex,
  InputGroup,
  Dialog,
  Portal,
  Text,
} from '@chakra-ui/react';

const BIGGER_THEN_ZERO_ERR = 'Значення повинно бути більше 0';
const REFILL_BUTTON_TEXT = 'Поповнити';
const CLOSE_BUTTON_VALUE = '✕';
const REQUIRED_ERR = 'Поле обов’язкове';

export const RefillFuelTankDialog = ({
  setIsOpen,
  isOpen,
  onChange,
  handleAddSubmit,
  handleClose,
  tableHeaderItems = [],
  formValues = {},
}) => {
  const fields = tableHeaderItems.map((item) => {
    let startAddon = '';
    let endAddon = '';
    let placeholder = '';

    switch (item.key) {
      case 'liters':
        startAddon = 'л';
        endAddon = 'ЛІТРИ';
        placeholder = '0.00';
        break;
      case 'price':
        startAddon = '₴';
        endAddon = 'ГРН/Л';
        placeholder = '0.00';
        break;
      case 'note':
        placeholder = 'Коментар';
        break;
      default:
        break;
    }

    return {
      ...item,
      startAddon,
      endAddon,
      placeholder,
      value: formValues[item.key] ?? '',
    };
  });

  const getLitersError = (value) => {
    if (value === '' || value === undefined) return REQUIRED_ERR;
    if (Number(value) <= 0) return BIGGER_THEN_ZERO_ERR;
    return '';
  };

  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={setIsOpen}
      closeOnEscape
      closeOnInteractOutside
      trapFocus
      placement='center'
      motionPreset='slide-in-top'>
      <Portal>
        <Dialog.Backdrop backdropFilter='blur(8px)' />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Body>
              <Button
                position='absolute'
                top={2}
                right={2}
                size='sm'
                variant='ghost'
                onClick={handleClose}>
                {CLOSE_BUTTON_VALUE}
              </Button>
              <Flex direction='column' gap={4} mt={12}>
                {fields.map(
                  ({
                    key,
                    startAddon,
                    endAddon,
                    type,
                    value,
                    placeholder,
                    required,
                  }) => {
                    const litersError =
                      key === 'liters' ? getLitersError(value) : '';

                    return (
                      <Field.Root key={key} flex='1' required={required}>
                        <InputGroup startAddon={startAddon} endAddon={endAddon}>
                          <Input
                            name={key}
                            type={type}
                            value={value}
                            onChange={onChange}
                            placeholder={placeholder}
                            borderColor={
                              key === 'liters' && litersError && 'red.500'
                            }
                          />
                        </InputGroup>
                        {key === 'liters' && litersError && (
                          <Text color='red.500' fontSize='12px'>
                            {litersError}
                          </Text>
                        )}
                      </Field.Root>
                    );
                  }
                )}
              </Flex>
              <Box minW={{ base: '100%', md: '128px' }} mt={8}>
                <Button
                  disabled={!!getLitersError(formValues.liters)}
                  onClick={handleAddSubmit}
                  fontWeight='bold'
                  fontSize='md'
                  w='full'
                  border='1px solid'
                  borderColor='gray.400'
                  boxShadow='md'
                  _hover={{ bg: 'gray.100', color: 'gray.900' }}>
                  {REFILL_BUTTON_TEXT}
                </Button>
              </Box>
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
